import { createSelector } from 'reselect';

const selectTaxProviders = (state: any) => state.taxProviders;


export const selectTaxProvidersCurrentItem = createSelector([selectTaxProviders], (taxProviders) => taxProviders.current);

export const selectTaxProvidersListItems = createSelector([selectTaxProviders], (taxProviders) => taxProviders.list);

export const selectTaxProvidersItemById = (itemId: any) =>
    createSelector(selectTaxProvidersListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectTaxProvidersCreatedItem = createSelector([selectTaxProviders], (taxProviders) => taxProviders.create);

export const selectTaxProvidersUpdatedItem = createSelector([selectTaxProviders], (taxProviders) => taxProviders.update);

export const selectTaxProvidersReadItem = createSelector([selectTaxProviders], (taxProviders) => taxProviders.read);

export const selectTaxProvidersDeletedItem = createSelector([selectTaxProviders], (taxProviders) => taxProviders.delete);

export const selectTaxProvidersSearchedItems = createSelector([selectTaxProviders], (taxProviders) => taxProviders.search);

export const selectTaxProvidersItemsCount = createSelector([selectTaxProviders], (taxProviders) => taxProviders.count);

export const selectTaxProvidersItemsFilter = createSelector([selectTaxProviders], (taxProviders) => taxProviders.filter);